import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Aggregate,
  AggregateColumnsDirective,
  AggregateColumnDirective,
  AggregateDirective,
  AggregatesDirective,
  Edit,
  Toolbar,
  Group,
  Sort,
  Inject,
  FilterSettingsModel,
  Filter,
  ExcelExport,
  ExcelQueryCellInfoEventArgs,
  Reorder,
  Resize,
  // PdfQueryCellInfoEventArgs,
} from "@syncfusion/ej2-react-grids";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { ClickEventArgs } from "@syncfusion/ej2-navigations";
import { useRef } from "react";

import { FIRType } from "../../../../db/model";
import ErrorBoundary from "../../../../ErrorBoundary";

let refresh: Boolean;

function FirComponent({ firData }: { firData: FIRType[] }) {
  const gridInstance = useRef<GridComponent>(null);
  const alertDialogInstance = useRef<DialogComponent>(null);

  const filterSettings: FilterSettingsModel = { type: "Excel" };
  const toolbarOptions: any = ["ExcelExport"];
  const editSettings: any = { allowEditing: false };
  // const editparams: any = { params: { popupHeight: "300px" } };
  // const partyNameRule: Object = { required: true };
  // const orderNoRules: Object = { required: true };
  const dateFormat: any = { type: "date", format: "dd-MMM-yyyy" };

  // const groupOptions: Object = { showGroupedColumn: false, columns: ["rate"] };
  const groupOptions: Object = { showGroupedColumn: false, columns: [] };
  const visible = false;
  const animationSettings: Object = { effect: "None" };
  const alertButtons = [
    {
      click: () => {
        alertDialogInstance.current?.hide();
      },
      buttonModel: { content: "OK", isPrimary: true },
    },
  ];

  function dataBound() {
    if (refresh) {
      gridInstance.current?.groupColumn("rate");

      refresh = false;
    }
  }

  function exportQueryCellInfo(args: ExcelQueryCellInfoEventArgs) {
    // if (args.column!.headerText === "Employee Image") {
    //   if ((args as any).name === "excelQueryCellInfo") {
    //     args.image = {
    //       height: 75,
    //       base64: args.data["EmployeeImage"],
    //       width: 75,
    //     };
    //   } else {
    //     args.image = { base64: args.data["EmployeeImage"] };
    //   }
    // }
    // if (args.column!.headerText === "Email ID") {
    //   args.hyperLink = {
    //     target: "mailto:" + args.data["EmailID"],
    //     displayText: args.data["EmailID"],
    //   };
    // }
  }

  function load() {
    // to do
  }

  function columnDragStart(args: any) {
    if (args.column.field === "referenceNo") {
      alertDialogInstance.current?.show();
    }
  }

  function created() {
    gridInstance.current?.on("columnDragStart", columnDragStart);
  }

  function toolbarClick(args: ClickEventArgs): void {
    if (args.item.id?.endsWith("_excelexport")) {
      console.log("args.item.id");
      console.log(args.item.id);
      if (gridInstance.current) {
        gridInstance.current.excelExport();
      }
    }
  }

  let modifiedFirData = firData.map((item) => {
    return {
      ...item,
      receiptDate: item.receiptDate ? new Date(item.receiptDate) : null,
      challanDate: item.challanDate ? new Date(item.challanDate) : null,
    };
  });

  function amountSum(props: any) {
    return <span>Sum: {props.Sum.toFixed(2)}</span>;
  }

  return (
    <ErrorBoundary>
      <div className="w-full pb-12 min-h-screen">
        <div className="control-pane mx-auto py-3">
          <div className="control-section">
            <GridComponent
              className="mx-auto dark:bg-slate-950"
              dataSource={modifiedFirData}
              allowPaging={true}
              allowExcelExport={true}
              ref={gridInstance}
              toolbar={toolbarOptions}
              toolbarClick={(e) => toolbarClick(e)}
              pageSettings={{ pageCount: 5, pageSize: 15 }}
              allowFiltering={true}
              enableAltRow={true}
              filterSettings={filterSettings}
              editSettings={editSettings}
              allowGrouping={true}
              groupSettings={groupOptions}
              allowSorting={true}
              rowHeight={25}
              height="auto"
              dataBound={() => dataBound()}
              excelQueryCellInfo={(e) => exportQueryCellInfo(e)}
              load={load}
              created={created}
              allowReordering={true}
              allowResizing={true}
            >
              <ColumnsDirective>
                <ColumnDirective
                  allowGrouping={false}
                  field="receiptNo"
                  headerText="Receipt No."
                  width="130"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="receiptDate"
                  headerText="Receipt Date"
                  width="150"
                  textAlign="Left"
                  format={dateFormat}
                />
                <ColumnDirective
                  field="partyName"
                  headerText="Party Name"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="challanNo"
                  headerText="Challan No."
                  width="130"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="challanDate"
                  headerText="Challan Date"
                  width="150"
                  textAlign="Left"
                  format={dateFormat}
                />
                <ColumnDirective
                  field="fabricType"
                  headerText="Fabric Type"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="category"
                  headerText="Category"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="fabric"
                  headerText="Fabric"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="orderForm"
                  headerText="Order Form"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="quantity"
                  headerText="Quantity"
                  width="120"
                  textAlign="Right"
                  // format="N0"  // Assuming the quantity is a whole number
                />
                <ColumnDirective
                  field="unit"
                  headerText="Unit"
                  width="100"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="shade"
                  headerText="Shade"
                  width="130"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="clientPO"
                  headerText="Client PO"
                  width="150"
                  textAlign="Left"
                />
              </ColumnsDirective>
              <AggregatesDirective>
                <AggregateDirective>
                  <AggregateColumnsDirective>
                    <AggregateColumnDirective
                      field="quantity"
                      type="Sum"
                      groupFooterTemplate={amountSum}
                      footerTemplate={amountSum}
                    />
                  </AggregateColumnsDirective>
                </AggregateDirective>
              </AggregatesDirective>
              <Inject
                services={[
                  Page,
                  Toolbar,
                  ExcelExport,
                  Aggregate,
                  Group,
                  Sort,
                  Edit,
                  Filter,
                  Reorder,
                  Resize,
                ]}
              />
            </GridComponent>
            <DialogComponent
              id="alertDialog"
              header="Grouping"
              visible={visible}
              animationSettings={animationSettings}
              width="300px"
              content="Grouping is disabled for this column"
              ref={alertDialogInstance}
              target=".control-section"
              buttons={alertButtons}
            />
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
}

export default FirComponent;
